export enum CorporateInvoiceForms {
  Create = 'CreateCorporateInvoice',
  Remove = 'RemoveCorporateInvoice',
  Resend = 'ResendCorporateInvoice',
  Regenerate = 'RegenerateCorporateInvoice',
}
